import React from 'react';
import InfoBox from '../../../libs/react-components-admin/box/info-box';

const IntegrationOnlyForStandalone = () => <InfoBox>
  <span className="material-icons align-bottom">info</span> Only works for forms displayed on a standalone page.<br />
</InfoBox>;
export default IntegrationOnlyForStandalone;